<template>
    <div>
        <v-dialog v-model="dialog_registration_type" no-click-animation scrollable persistent transition="dialog-bottom-transition">
            <v-card style="border-radius: 5px !important;">
                <v-card-text full-height nopadding>

                    <v-list>

                        <v-list-item v-for="(item, index) in registrationTypes" :key="index" @click="fn_updateRegistrationType(item)">
                            <v-list-item-content>
                                <v-list-item-title>{{item.name}}</v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-icon v-if="item.status == selectedRegistrationType">mdi-radiobox-marked</v-icon>
                                <v-icon v-else>mdi-radiobox-blank</v-icon>
                            </v-list-item-action>
                        </v-list-item>
                        
                    </v-list>
                </v-card-text>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>
    export default{
        props:['registrationTypes', 'selectedRegistrationType'],
        data(){
            return{
                dialog_registration_type:false,
                hide_overlay:true
            }
        },
        methods:{
            openDialogWeb: function () {
                this.dialog_registration_type = true;
            },
            closeDialogWeb: function () {
                this.dialog_registration_type = false;
            },
            fn_updateRegistrationType: function(item){
                console.log('regtype');
                this.$parent.Form.GSTRegistrationStatus = item.status;
                this.$parent.errors.remove('regType');
                if(item.status == 1){
                    this.$parent.Form.TaxMode = 1;
                    this.$parent.Form.HSNApplicable = true;
                }
                else{
                    this.$parent.Form.TaxMode = 0;
                    this.$parent.Form.HSNApplicable = false;
                }
                this.$parent.fn_closeDialog();
            }
        }
    }
</script>